import React, { Component } from 'react';
import classNames from 'classnames';
import { mergeStyles } from 'wix-rich-content-common';
import Tooltip from 'wix-rich-content-common/libs/Tooltip';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { omit } from 'lodash';
import SearchIcon from '../Icons/SearchIcon.js';
import ErrorIcon from '../Icons/ErrorIcon.js';

var css_248z = "._0qabU,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.zWYDQ{position:relative}.zWYDQ:hover svg{fill:var(--ricos-settings-icons-color,#000)}.DBzle{box-sizing:border-box;color:var(--ricos-settings-text-color,#333);font-family:var(--ricos-settings-text-font-family,HelveticaNeue,Helvetica,Arial);font-size:16px;font-weight:300;height:42px;line-height:1.5;width:100%}[dir] .DBzle{border:1px solid var(--ricos-settings-inputs-border-color,rgba(0,0,0,.6))!important;border-radius:var(--ricos-settings-inputs-border-radius,0)!important}[dir=ltr] .DBzle{padding-left:18px}[dir=rtl] .DBzle{padding-right:18px}.DBzle::placeholder{color:var(--ricos-settings-inputs-placeholder-color,rgba(0,0,0,.6))}[dir] .DBzle:hover{border:1px solid rgba(var(--ricos-settings-action-color-tuple,0,0,0),.5)!important}[dir=ltr] .DBzle.uDGWR{padding-left:34px}[dir=rtl] .DBzle.uDGWR{padding-right:34px}[dir] .Sr4dj{border-color:red}[dir=ltr] .Sr4dj{padding-right:39px}[dir=rtl] .Sr4dj{padding-left:39px}.D9A-c{bottom:0;color:#ee5951;position:absolute;top:0;width:13px}[dir] .D9A-c{margin:auto}[dir=ltr] .D9A-c{right:13px}[dir=rtl] .D9A-c{left:13px}.EsVf-{fill:rgba(0,0,0,.6);bottom:0;position:absolute;top:0;width:24px}[dir] .EsVf-{margin:auto}[dir=ltr] .EsVf-{left:7px}[dir=rtl] .EsVf-{right:7px}.ckPSc{fill:var(--ricos-settings-icons-color,#000)}.D5GfU{fill:rgba(0,0,0,.6)}";
var textInputStyles = {"fontElementMap":"_0qabU","textInput":"zWYDQ","textInput_input":"DBzle","searchIcon":"uDGWR","textInput_input_invalid":"Sr4dj","textInput_errorIcon":"D9A-c","prefixIcon":"EsVf-","focusFill":"ckPSc","unfocusFill":"D5GfU"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
class TextInput extends Component {
  constructor(props) {
    super(props);
    this.handleOnChange = (event) => {
      const { onChange, getTarget } = this.props;
      onChange == null ? void 0 : onChange(getTarget ? event.target : event.target.value);
    };
    this.focusSearchIcon = () => {
      this.setState({ focusSearchIcon: true });
    };
    this.unfocusSearchIcon = () => {
      this.setState({ focusSearchIcon: false });
    };
    this.state = {
      focusSearchIcon: true
    };
  }
  render() {
    const _a = this.props, {
      inputRef,
      error,
      theme,
      showTooltip,
      searchIcon = false,
      dataHook,
      showErrorIcon,
      placeholder,
      style
    } = _a, otherProps = __objRest(_a, [
      "inputRef",
      "error",
      "theme",
      "showTooltip",
      "searchIcon",
      "dataHook",
      "showErrorIcon",
      "placeholder",
      "style"
    ]);
    const inputProps = omit(otherProps, ["onChange"]);
    const styles = mergeStyles({ styles: textInputStyles, theme });
    const { focusSearchIcon } = this.state;
    return /* @__PURE__ */ React.createElement("div", { className: styles.textInput, "data-hook": dataHook }, searchIcon && /* @__PURE__ */ React.createElement(
      SearchIcon,
      {
        className: classNames(styles.prefixIcon, {
          [styles.unfocusFill]: !focusSearchIcon,
          [styles.focusFill]: focusSearchIcon
        })
      }
    ), /* @__PURE__ */ React.createElement(
      "input",
      __spreadValues({
        placeholder,
        ref: inputRef,
        className: classNames(styles.textInput_input, {
          [styles.textInput_input_invalid]: error,
          [styles.searchIcon]: searchIcon
        }),
        onChange: this.handleOnChange,
        onFocus: this.focusSearchIcon,
        onBlur: this.unfocusSearchIcon,
        onDoubleClick: otherProps == null ? void 0 : otherProps.onDoubleClick,
        style
      }, inputProps)
    ), error && showErrorIcon && (showTooltip ? /* @__PURE__ */ React.createElement(Tooltip, { isError: true, content: error }, /* @__PURE__ */ React.createElement(ErrorIcon, { className: styles.textInput_errorIcon })) : /* @__PURE__ */ React.createElement(ErrorIcon, { className: styles.textInput_errorIcon })));
  }
}
TextInput.defaultProps = {
  showTooltip: true,
  showErrorIcon: true
};

export { TextInput as default };
//# sourceMappingURL=TextInput.js.map
